import { useMutation } from 'react-query'
import { useNotification } from 'components/Notification'
import { postPeopleMergeReview } from 'services/people'
import { transformJobMappingsForAPI } from '../utils'

function usePeopleMergeReviewMutation() {
  const { createNotification } = useNotification()

  const {
    data,
    mutateAsync: fetchReview,
    isLoading,
    isError,
    error,
    reset: clearReview,
  } = useMutation(
    ({ sourceId, targetId, jobMappings }) => {
      const { jobMappings: apiMappings, jobOverrides } = transformJobMappingsForAPI(jobMappings)
      return postPeopleMergeReview(sourceId, targetId, apiMappings, jobOverrides)
    },
    {
      retry: false,
      onError: error => {
        createNotification({
          message: error?.response?.data?.errors?.[0]?.message || 'Failed to load merge preview',
          variant: 'error',
        })
      },
    },
  )

  return {
    data,
    fetchReview,
    isLoading,
    isError,
    error,
    clearReview,
  }
}

export default usePeopleMergeReviewMutation
